(function ($, XTT) {
	'use strict';

	XTT.certificacao = {
		_autoload: [
			'bindCNPJMask'
		],

		bindCNPJMask: function () {
			$('input[data-mask]')
				.each(function () {
					var input = $(this);
					input.setMask(input.data('mask'));
				});
		}

	};

})
(jQuery, XTT);